// 找商机-信息卡片
<template>
  <div class="v-opportunity-view" v-loading="loading">
    <!-- 头像 -->
    <div class="header-img-view" :class="{'header-img-view-hover': item.operateSubjectType != subjectType && subjectType == 'VISITOR'}" @click.stop="detail">
      <el-avatar :size="96" :src="$funcs.compressImage(item.headPortrait, 96, 96) || defImage('head')"></el-avatar></div>
    <div class="right-view">
      <!-- title部分 -->
      <div>
        <span class="op-title-text" :class="{'op-title-text-hover': item.operateSubjectType != subjectType && subjectType == 'VISITOR'}" @click.stop="detail">{{item.operateSubjectType == 'ACTOR' ? (item.companyName || item.commercialName) : item.commercialName}}</span>
        <span class="op-desc-text" v-show="item.operateSubjectType == 'VISITOR'">{{item.post}}</span>
        <div class="op-bottom-desc-text">
          <span>{{item.operateSubjectType == 'ACTOR' ? item.bthCode : item.companyName}}</span>
        </div>
      </div>
      <!-- 内容部分 -->
      <div class="op-content-view">
        <div class="op-content-text">
          <span class="p">{{item.content}}</span>
        </div>
        <el-row :gutter="12">
          <el-col :span="8" v-for="(item, index) in getImgArr(item.imgUrl)" :key="index">
            <el-image
            style="width: 180px; height: 180px; margin-top:12px"
            :src="$funcs.compressImage(item, 180, 180)"
            fit="cover"
            :preview-src-list="[item]">
            </el-image>
          </el-col>
          <el-col :span="8" v-if="item.videoUrl != ''" style="position: relative">
            <div style="margin-top:12px; position: relative;">
              <div class='v--video-img' style="height: 180px" @click="goPlay(item)">
                <span class="icon-video"></span>
              </div>
              <!-- <img :src="item.previewImageUrl || defImage('product3')" class="opportunity-img"/> -->
              <video
                style="object-fit: cover; height: 180px"
                class="opportunity-img"
                :poster="item.previewImageUrl"
                :src="item.videoUrl"
                >
              </video>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 时间/评论/点赞/邀约/删除-操作按钮 -->
      <el-row class="op-bottom-view">
        <el-col :span="12">
          <span class="time-label">{{item.createTime}}</span>
        </el-col>
        <el-col :span="12">
          <div class="operate-view">
            <!-- <el-button type="text" class="operate-btn" @click="changeCommentStatus(!showComment, '')"><i class="iconfont iconhuifu comment-icon"></i>{{$t('comment')}}</el-button> -->
            <!-- <el-button type="text" class="operate-btn" @click="clickLike"><i class="iconfont like-icon" :class="item.iSure ? 'iconact_dianzan_full' : 'icondianzan'"></i>{{item.likeTotal}} {{$t('like')}}</el-button> -->
            <!-- <el-button :class="item.invite ? 'invite-btn-disable' : 'invite-btn'" type="primary" size="mini" v-show="invitedShowStatus()" @click="invite(item)" :disabled="item.invite">
              {{item.invite ? $t('finds.invited') : $t('invite')}}
            </el-button> -->
            
            <template v-if="item.userAccountId != info.userAccountId && (this.styleType =='exhibitor' || this.styleType=='visitor') && invitedShowStatus()">
              <template>
                <div style="display: inline-block;" class="pointer disabled" v-if="item['invite']" @click.stop>
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('finds.invited') }}</span>
                </div>
                <div style="display: inline-block;" class="pointer" @click.stop="invite(item)" v-else>
                  <span class="iconfont iconyaoyue theme-icon-primary-color"></span>
                  <span>{{ $t('invite') }}</span>
                </div>
              </template>
              <div style="display: inline-block;" class="pointer" @click.stop="msg(item)">
                <span class="iconfont iconxiaoxi_weixuanzhong theme-icon-primary-color"></span>
                <span>{{ $t('message') }}</span>
              </div>
            </template>

            <el-button class="delete-btn" type="text" size="mini" v-show="styleType=='exhibitor-edit' || styleType=='visitor-edit'" @click="deleteCommercial">{{$t('del')}}</el-button>
          </div>
        </el-col>
      </el-row>
      <!-- 评论区 -->
       <div v-if="false">
         <comment-item v-for="(commentItem, index) in item.data" :key="'comment' + index" :item="commentItem" @clickComment="changeCommentStatus"></comment-item>
       </div>
      <!-- 评论框 -->
      <transition name="el-fade-in-linear" >
        <div class="op-comment-input" v-show="showComment && false">
          <!-- :placeholder="$t('homes.searchPlaceHolder')" -->
          <el-input
            type="textarea"
            :rows="3"
            
            v-model="commentText"
            @input="inputComment"
            >
          </el-input>
          <el-button class="save-btn" type="primary" size="mini" @click="saveComment">{{$t('op_publish')}}</el-button>
        </div>
      </transition>
    </div>

    <v-video style="width:100%" :isShow="isShowV" @callback="callback" :src="videoUrl"></v-video>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import commentItem from './commentItem.vue'
// import { eventMixin } from '@/mixins/event.js'
// import { inviteMixin } from '@/mixins/inviteEvent.js'
import { addCommercialDistrictComment, addCommercialDistrictLike, deleteCommercialDistrict } from '../../api/opportunity.js'
import vVideo from '@/components/vVideo'

export default {
  // mixins: [eventMixin, inviteMixin],
  components: {
    commentItem,
    vVideo
  },
  props: {
    // 样式Type: exhibitor(展商) / visitor(客商) / exhibitor-edit(展商-编辑) / visitor-edit(客商编辑)
    styleType: {
      type: String,
      default: "exhibitor"
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      showComment: false,    // 是否显示评论框
      commentText: '',
      loading: false,
      commentSubObj: {},       // 被评论条目数据
      isShowV: false,
      videoUrl: '',
    }
  },
  computed: {
    ...mapGetters(['visitorId', 'exhibitionId', 'exhibitorId', 'subjectType', 'info'])
  },
  mounted() {},
  methods: {
    //消息
    msg(data) {
      let item = {
        atrName: data.companyName || data.companyEName,
        exhibitId: data.operateSubjectId,
        exhibitionId: data.exhibitionId,
        exhibitorId: data.operateSubjectId,
        operateSubjectType: data.operateSubjectType,
        userAccountId: data.userAccountId
      }
      console.log('item--->', item)
      this.$emit('msg', item)
    },
    // 跳转详情
    detail() {
      if (this.item.operateSubjectType != this.subjectType) {
        if (this.subjectType == 'ACTOR') {
          return true
          // this.pageDetail({id: this.item.operateSubjectId, ...this.item}, 'person')
        } else {
          this.pageDetail({id: this.item.operateSubjectId, ...this.item}, 'actor')
        }
      }
      
    },
    goPlay(item) {
      this.isShowV = true
      this.videoUrl = item.videoUrl
    },
    callback() {
      this.isShowV = false
      this.videoUrl = ''
    },
    // 评论框
   changeCommentStatus (status, item) {
     if(!this.todoPrission()) return
     this.showComment = status;
     this.commentSubObj = item;
     if (status) {
       this.commentText = '';
     }
   },
   inputComment (value) {
     this.commentText = value;
   },
   // 发表评论
   saveComment () {
      window.PC.$RangersEventOpportunity(this.subjectType, 'comment', this.item)
      var params = {
        commercialDistrictId: this.item.commercialDistrictId,
        commentContent: this.commentText,
        exhibitionId: this.$store.getters.subjectType,
      }
      if (this.commentSubObj !== '') {
        params['receiveCommentSubjectId'] = this.commentSubObj.commentSubjectId
      }
      this.loading = true;
      addCommercialDistrictComment(params).then(res => {
        return res.data
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
          let headImage = ''
          let name = this.$store.getters.name
          if (this.subjectType == 'VISITOR') {
            headImage = this.info['visitor']['headImage'];
          }
          if (this.subjectType == 'ACTOR') {
            headImage = this.info['exhibitorEmployee']['exhibitor']['logoImage'];
            name = this.info['exhibitorEmployee']['exhibitor']['name']
          }
          let commentData = {
            commentContent: this.commentText,
            commentName: name,
            receiveCommentName: this.commentSubObj.commentName,
            commentSubjectId: localStorage.getItem('info')['userAccountId'],
            commentTime: this.getNowDate(),
            headPortrait: headImage
          }
          this.showComment = false;
          var commentList = this.item['data'] ? this.item['data'] : [];
          commentList.splice(0, 0, commentData);
          this.item['data'] = commentList;
        }
      }).finally(() => {
        this.loading = false;
      })
   },
   // 点赞
   clickLike () {
     if(!this.todoPrission()) return
     this.requestLike();
     if (this.item.iSure) {
       // 自己点赞
       this.item.iSure = false;
       this.item.likeTotal -= 1;
       return;
     }
     if (!this.item.iSure) {
       // 自己没有点赞
       window.PC.$RangersEventOpportunity(this.subjectType, 'like', this.item)
       this.item.iSure = true;
       this.item.likeTotal += 1;
       return;
     }
   },
   requestLike () {
     var params = {
       commercialDistrictId: this.item.commercialDistrictId
     }
     addCommercialDistrictLike(params).then(res => {
       return res.data
     }).then(res => {
       console.log(res.data)
     }).finally(() => {
     })
   },
   // 删除商脉圈
   deleteCommercial () {
     var params = {
       id: this.item.commercialDistrictId
     }
     this.loading = true;
     deleteCommercialDistrict(params).then(res => {
       return res.data
     }).then(res => {
       this.loading = false;
       if (res.code === 1000) {
         // 通知父组建删除当前数据
         this.$emit('deleteItem', this.item.commercialDistrictId);
       }
     }).finally(() => {
       this.loading = false;
     })
   },
   // 邀约
    invite(item) {
     if (item.operateSubjectType == 'VISITOR') {
       this.inviteVisitorEvent();
     }
     if (item.operateSubjectType == 'ACTOR') {
       this.inviteActorEvent();
     }

   },
   // 邀约-展商邀请-客商
   inviteVisitorEvent () {
      // this.inviteEvent({
      //   projectId: this.$store.getters.info['projectId'],
      //   userId: this.item.operateSubjectId
      // }, (status) => {
      //   this.item.invite = status;
     // })
      let params = {
        projectId: this.info.projectId,
        userId: this.item.operateSubjectId
      }
      this.$emit(
        'invite',
        params,
        this.index,
        this.item
      )
   },
   // 邀约-客商邀请-展商 
   inviteActorEvent () {
     let params = {
        exhibitorName: this.item.companyName || this.item.companyEName,
        exhibitId: this.item.operateSubjectId,
        exhibitionId: this.item.exhibitionId,
        exhibitorId: this.item.operateSubjectId
      }
    //  this.inviteEventExh(params, (status) => {
    //    this.item.invite = status;
     //  }, 'exhibitors');

     this.$emit(
        'invite',
        params,
        this.index,
        this.item
      )
   },
   // 获取是否隐藏邀约按钮
   invitedShowStatus () {
     if (this.subjectType == 'VISITOR' && this.visitorId == this.item.operateSubjectId) {
       return false;
     }
     if (this.subjectType == 'ACTOR' && this.exhibitorId == this.item.operateSubjectId) {
       return false;
     }
     if (this.styleType=='exhibitor' || this.styleType=='visitor') {
       return true;
     }
    //  return false;
   },
   // 将img字符串转为数组
   getImgArr (str) {
     if (str == "" || !str) {
       return [];
     }
     var imgArr = str.split(",");
     return imgArr;
   },
   // 获取当前时间
   getNowDate () {
     var time=new Date();
    //  var date = time.getFullYear() + '-' + time.getMonth() + '-' + time.getDate() + ' ' + time.getHours() + ':' + time.getMinutes();
     return time;
   }
  }
}
</script>
<style lang="stylus" scoped>
.opportunity-img {
  width: 180px;
  height: 180px;
  object-fit: contain;
  background: $color-white;
}

.v-opportunity-view {
  padding-top: 30px;
  display: flex;
  .header-img-view {
    &.header-img-view-hover {
      position relative
      cursor pointer

      .el-avatar{
        position relative

        &:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background-color: $color-black-15
          opacity: 0;
          transition all .3s
        }

        &:hover:before {
          opacity: 1;
        }
      }
    }
  }
  .right-view {
    padding-left :25px;
    flex: 1;
    .op-title-text {
      font-size : 20px;
      font-family : PingFangSC-Regular,PingFang SC;
      font-weight : 400;
      color : $color-black;

      &.op-title-text-hover {
        cursor: pointer

        &:hover {
          color: $color-main-hover
        }
      }
    }
    .op-desc-text {
      margin-left : 8px;
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color : $color-black-45;
    }
    .op-bottom-desc-text {
      margin-top : 8px;
      margin-bottom : 16px;
      >span {
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color : $color-black-45;
      }
    }
  }
  .op-content-view {
    width : 612px;
    background-color : $color-gray-fb;
    padding : 24px;
    .op-content-text {
      margin-bottom 12px;
      > span {
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color : $color-black-65;
      }
    }
  }
  .op-bottom-view {
    width : 612px;
    padding-top : 8px;
    .time-label {
      line-height : 40px;
      font-size:16px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color : $color-black-45;
    }
    .operate-view {
      text-align : right;
      .operate-btn  {
        font-size:14px;
        font-family:PingFangSC-Light,PingFang SC;
        font-weight:300;
        color:$color-black-65;
        cursor:pointer;
      }
      .comment-icon {
        color: $color-main;
      }
      .like-icon {
        color: $color-red-fc;
      }
      .invite-btn {
        background-color : $color-main;
        margin-left 24px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
      }
      .invite-btn-disable {
        margin-left 24px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
      }
      .delete-btn {
        margin-left 24px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:$color-main;
      }
    }
  }
  .op-comment-input {
    margin-top 16px;
    width : 612px;
    position: relative;
    .save-btn {
      position: absolute;
      bottom: 14px;
      right: 8px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
    }
  }
  .op-like-detail-view {
    margin-top : 25px;
    width : 612px;
    >div {
      >span {
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:$color-black-65;
      }
      >p {
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color: $color-black;
        display: inline-block;
      }
    }
    .like-header {
      margin-left : 4px;
      margin-right : 4px;
      margin-top 12px;
    }
  }
  .op-tag-view {
    margin-top 24px;
    >span {
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:$color-black-65;
    }
    >div {
      margin-top : 8px;
      .op-tag {
        border-radius : 12px;
        border-color : $color-light9;
        color: $color-main;
        background-color : $color-light9;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        margin: 0px 3px;
      }
    }
  }
}

.v--video-img{
  position absolute
  width: 100%
  height: 100%
  z-index 10
}
</style>